import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withStyles, Grid } from '@material-ui/core';
import { FHEContainerForm, FHEItemText } from 'data/components';

class Relay extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        line: PropTypes.object.isRequired
    };

    render() {
        const { line, classes } = this.props;
        return (
            <FHEContainerForm>
                <Grid container spacing={3}>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.label')} itemContent={line.get('label')} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.macAddress')}
                            itemContent={
                                line.get('macAddress')
                                    ? line
                                          .get('macAddress')
                                          .match(/.{1,2}/g)
                                          .join(':')
                                    : 'N/A'
                            }
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.type')}
                            itemContent={Translator.translate(`general.productModules.${line.get('type')}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.code')} itemContent={line.get('code')} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.planningMode')}
                            itemContent={Translator.translate(`general.productModules.${line.get('planningMode')}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.mode')}
                            itemContent={Translator.translate(`general.data.mode.${line.get('mode')}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.state')}
                            itemContent={line.get('state')}
                            classContent={line.get('state') === 'disconnected' ? classes.disconnectedColor : classes.connectedColor}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.planningSynched')}
                            itemContent={line.get('planningSynced') === 1 ? Translator.translate('general.yes') : Translator.translate('general.no')}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.reversePolarity')}
                            itemContent={
                                line.get('reversedPolarity') === 1 ? Translator.translate('general.yes') : Translator.translate('general.no')
                            }
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.threshold')} itemContent={line.get('threshold')} />
                    </Grid>
                </Grid>
            </FHEContainerForm>
        );
    }
}

const styles = theme => ({
    connectedColor: {
        color: theme.palette.success.main
    },
    disconnectedColor: {
        color: theme.palette.error.main
    }
});

export default withStyles(styles, { withTheme: true })(Relay);



// WEBPACK FOOTER //
// ./environments/fhepool/scenes/SDM17DEC/ProductModule/Relay/index.js